import React, { useState } from 'react'
import { Form, Input, Button, Typography } from 'antd'
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import axios from 'axios'
import { serverUrl } from '../../Constants'

const { Title, Text } = Typography

function ForgotPassword() {
    const history = useHistory()
    const [loading, setLoading] = useState(false)
    const [sent, setSent] = useState(false)

    const onFinish = async ({ email }: { email: string }) => {
        setLoading(true)
        try {
            await axios.post(`${serverUrl}auth/forgot-password`, { email })
        } catch (_) {
            // silencioso — respuesta genérica para no revelar si el email existe
        } finally {
            setLoading(false)
            setSent(true)
        }
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '80px' }}>
            <div style={{ width: '360px' }}>
                <Title level={4} style={{ marginBottom: '8px' }}>Recuperar contraseña</Title>

                {sent ? (
                    <>
                        <Text>
                            Si el correo está registrado, recibirás un enlace para restablecer tu contraseña en los próximos minutos.
                        </Text>
                        <Button
                            type="link"
                            icon={<ArrowLeftOutlined />}
                            style={{ paddingLeft: 0, marginTop: '16px', display: 'block' }}
                            onClick={() => history.push('/')}
                        >
                            Volver al inicio de sesión
                        </Button>
                    </>
                ) : (
                    <>
                        <Text type="secondary" style={{ display: 'block', marginBottom: '24px' }}>
                            Ingresa tu correo y te enviaremos las instrucciones para restablecer tu contraseña.
                        </Text>

                        <Form onFinish={onFinish} layout="vertical">
                            <Form.Item
                                name="email"
                                rules={[
                                    { required: true, message: 'Ingresa tu correo electrónico' },
                                    { type: 'email', message: 'El formato del correo no es válido' },
                                ]}
                            >
                                <Input
                                    prefix={<MailOutlined />}
                                    placeholder="Correo electrónico"
                                    autoFocus
                                />
                            </Form.Item>

                            <Form.Item style={{ marginBottom: '8px' }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    className="green"
                                    style={{ width: '100%' }}
                                >
                                    Enviar instrucciones
                                </Button>
                            </Form.Item>
                        </Form>

                        <Button
                            type="link"
                            icon={<ArrowLeftOutlined />}
                            style={{ paddingLeft: 0 }}
                            onClick={() => history.push('/')}
                        >
                            Volver al inicio de sesión
                        </Button>
                    </>
                )}
            </div>
        </div>
    )
}

export default ForgotPassword
